// @flow
export { default } from './components/MessageCenter';
